/* Aliviana — comportamiento compartido por las secciones propias. Hecho a medida, sin librerías. */
(function () {
  if (window.AlBase) return;

  /* Carrusel: [data-al-slider] > [data-al-track] > [data-al-slide], botones [data-al-prev]/[data-al-next],
     opcionales: data-al-auto="5" (segundos), data-al-loop, [data-al-dots], [data-al-bar] > i */
  function slider(root) {
    if (root.alSlider) return root.alSlider;
    var track = root.querySelector('[data-al-track]');
    if (!track) return null;
    var slides = [].slice.call(track.querySelectorAll('[data-al-slide]'));
    var prev = root.querySelector('[data-al-prev]'), next = root.querySelector('[data-al-next]');
    var dots = root.querySelector('[data-al-dots]'), bar = root.querySelector('[data-al-bar] i');
    var loop = root.hasAttribute('data-al-loop'), auto = parseFloat(root.getAttribute('data-al-auto')) || 0;
    var idx = 0, timer = null;

    function left(i) { return slides[i].offsetLeft - slides[0].offsetLeft; }
    function max() { return Math.max(0, track.scrollWidth - track.clientWidth); }
    function last() { for (var i = 0; i < slides.length; i++) { if (left(i) >= max() - 2) return i; } return slides.length - 1; }
    function current() {
      var x = track.scrollLeft, best = 0, d = Infinity;
      for (var i = 0; i < slides.length; i++) { var k = Math.abs(left(i) - x); if (k < d) { d = k; best = i; } }
      return best;
    }
    function paint() {
      var l = last();
      if (prev) prev.classList.toggle('is-off', !loop && idx <= 0);
      if (next) next.classList.toggle('is-off', !loop && idx >= l);
      if (dots) [].forEach.call(dots.children, function (b, i) { b.classList.toggle('is-on', i === idx); });
      if (bar) bar.style.width = (l > 0 ? ((idx + 1) / (l + 1)) * 100 : 100) + '%';
      root.classList.toggle('al-no-scroll', max() < 2);
    }
    function go(i, instant) {
      var l = last();
      if (i < 0) i = loop ? l : 0;
      if (i > l) i = loop ? 0 : l;
      idx = i;
      track.scrollTo({ left: left(i), behavior: instant ? 'auto' : 'smooth' });
      paint();
      root.dispatchEvent(new CustomEvent('al:slide', { detail: { index: i }, bubbles: true }));
    }
    if (prev) prev.addEventListener('click', function () { go(idx - 1); restart(); });
    if (next) next.addEventListener('click', function () { go(idx + 1); restart(); });
    if (dots) {
      dots.innerHTML = '';
      slides.forEach(function (_, i) {
        var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Ir a ' + (i + 1));
        b.addEventListener('click', function () { go(i); restart(); }); dots.appendChild(b);
      });
    }
    var st = null;
    track.addEventListener('scroll', function () {
      clearTimeout(st);
      st = setTimeout(function () {
        var c = current();
        if (c !== idx) { idx = c; paint(); root.dispatchEvent(new CustomEvent('al:slide', { detail: { index: c }, bubbles: true })); }
      }, 90);
    }, { passive: true });

    /* arrastre con mouse en escritorio */
    var down = false, sx = 0, sl = 0, moved = false;
    track.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse' || e.button !== 0) return; down = true; moved = false; sx = e.clientX; sl = track.scrollLeft; });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - sx;
      if (!moved && Math.abs(dx) > 6) { moved = true; track.classList.add('is-drag'); }
      if (moved) track.scrollLeft = sl - dx;
    });
    window.addEventListener('pointerup', function (e) {
      if (!down) return; down = false;
      if (!moved) return;
      var dx = e.clientX - sx; track.classList.remove('is-drag');
      var c = current(); if (c === idx && Math.abs(dx) > 40) c = idx + (dx < 0 ? 1 : -1);
      go(c); restart();
    });
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });

    function restart() { if (!auto) return; clearInterval(timer); timer = setInterval(function () { if (!root.matches(':hover') && document.visibilityState === 'visible') go(idx + 1); }, auto * 1000); }
    restart();
    window.addEventListener('resize', function () { go(idx, true); });
    paint();
    root.alSlider = { go: go, get index() { return idx; } };
    return root.alSlider;
  }

  function money(cents) {
    var n = Math.round(cents / 100);
    return '$' + String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function init(scope) {
    [].forEach.call((scope || document).querySelectorAll('[data-al-slider]'), slider);
  }

  window.AlBase = { slider: slider, money: money, init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
